module.exports = __webpack_public_path__ + "static/media/c4.b6a98e1e.gif";